import { Size } from '@/models/Size';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<SizeAutocomplete>({})
export default class SizeAutocomplete extends Vue {
  // #region @VModels
  // #endregion

  // #region @Props

  @Prop({ default: 'Size' })
  protected label!: string;

  @Prop({ default: () => new Size() })
  protected model!: Size;

  @Prop({ default: 'Size' })
  protected placeholder!: string;

  @Prop({ default: false })
  protected hideLabel!: boolean;

  // #endregion

  //

  // #region @Refs
  // #endregion

  // #region Class properties
  // #endregion

  // #region Lifecycle Hooks / Init
  // #endregion

  // #region Class methods
  // #endregion

  // #region Async methods
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}

// #region Enums
// #endregion

// #region Types
// #endregion

// #region Interfaces
// #endregion
